export const WASHROOM_LOGS_TABLE_HEADERS = ["Full Name", "Cleaning Date", "Start Time", "Washroom"];
export const MANAGER_WASHROOMS_TABLE_HEADERS = ["id", "label", "Edit Washroom"];
export const CLIENT_WASHROOMS_TABLE_HEADERS = ["id", "label"];
export const WASHROOMS_TABLE_HEADERS_SELECT = ["Select", "id", "label", "Edit Washroom"];

export const WASHROOM_LOGS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/washroomlogs", name: "Clients" },
  { id: "/washroomlogs/:clientCode", name: ":clientCode" },
  { id: "/washroomlogs/:clientCode/:locationId", name: ":locationId" },
];

export const CLIENTS_WASHROOM_LOGS_BREADCRUMBS = [
  { id: "/washroomlogs", name: "Home" },
  { id: "/washroomlogs?user=client", name: ":clientCode" },
  { id: "/washroomlogs?user=client&location=:locationId", name: ":locationId" },
];

export const DEFAULT_PAGE_SIZE = 10;
export const INITIAL_LAST_PAGE = 1000000000;
